import { Component, ElementRef, ViewChild } from "@angular/core";
import { DataService } from "../data.service";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { dataType } from "../dataType";
import { ToastrManager } from "ng6-toastr-notifications";

@Component({
  selector: "app-add-user",
  templateUrl: "./add-user.component.html",
  styleUrls: ["./add-user.component.css"]
})
export class AddUserComponent {
  data = new dataType();
  public selectedFile = null;
  public pic;
  userData = {
    DesiredDeliveryMediums: [],
    userAttributes: [],
    otherData: {},
    ValidationData: []
  };

  constructor(
    private dataService: DataService,
    private router: Router,
    private http: HttpClient,
    private toastr: ToastrManager
  ) {}

  acceptedMimeTypes = ["image/gif", "image/jpeg", "image/png"];

  @ViewChild("fileInput")
  fileInput: ElementRef;
  fileDataUri = "";
  errorMsg = "";

  previewFile() {
    const file = this.fileInput.nativeElement.files[0];
    if (file && this.validateFile(file)) {
      const reader = new FileReader();
      reader.readAsDataURL(this.fileInput.nativeElement.files[0]);
      reader.onload = () => {
        this.fileDataUri = JSON.stringify(reader.result);
      };
    } else {
      this.errorMsg =
        "File must be jpg, png, or gif and cannot be exceed 500 KB in size";
    }
  }

  uploadFile(event: Event) {
    event.preventDefault();

    // get only the base64 file
    if (this.fileDataUri.length > 0) {
      const base64File = this.fileDataUri.split(",")[1];
      // TODO: send to server
      // console.log(base64File);

      this.dataService
        .uploadImage({ image: base64File, bucket: "admin-panel-test" })
        .subscribe(res => {
          if (typeof res == "string") {
            res = JSON.parse(res);
          }
          console.log(res);

          if (res.Status == "Success") {
            this.pic = res.Data.Location;
            this.toastr.successToastr('Image Uploaded', 'Success!');
          } else {
            // console.log("Image uploading failed");
            this.toastr.errorToastr(res.Error.message, 'Oops!');
          }
        });
    }
  }

  validateFile(file) {
    return this.acceptedMimeTypes.includes(file.type) && file.size < 500000;
  }

  addUser() {
    this.save();
  }

  private save(): void {
    console.log(this.data);
    this.data.sms == true
      ? this.userData.DesiredDeliveryMediums.push("SMS")
      : null;
    this.data.cemail == true
      ? this.userData.DesiredDeliveryMediums.push("EMAIL")
      : null;

    this.userData.userAttributes.push(
      {
        Name: "email",
        Value: this.data.email
      },
      {
        Name: "phone_number",
        Value: this.data.phonenumber
      },
      {
        Name: "email_verified",
        Value: this.data.chkemail == true ? "true" : "false"
      },
      {
        Name: "phone_number_verified",
        Value: this.data.chkphonenumber == true ? "true" : "false"
      },
      {
        Name: "picture",
        Value: this.pic
      }
    );

    let validationData = {
      Name: "email",
      Value: this.data.email
    };

    this.userData.ValidationData.push(validationData);
    this.userData["otherData"] = {
      username: this.data.username,
      tempPass: this.data.temppass,
      region: localStorage.getItem("region"),
      poolId: localStorage.getItem("poolId")
    };

    console.log(this.userData);
    this.dataService.addUser(this.userData).subscribe((Data: any) => {
      console.log(Data);
      if (typeof Data == "string") {
        var newData = JSON.parse(Data);
      } else {
        var newData = Data;
      }
      console.log(newData);
      if (newData.Status == "Error") {
        console.log(newData.Error.message);
        // alert(newData.Error.message);
        this.toastr.errorToastr(newData.Error.message, 'Oops!');
      } else if (newData.Status == "Success") {
        // alert("User Created Successfully");
        this.toastr.successToastr('User Created Successfully', 'Success!');

        this.router.navigate(["/users"]);
      }
    });
  }
}
